import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Lenis from "lenis";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Municipality from "@/pages/Municipality";
import CandidateProfile from "@/pages/CandidateProfile";
import Issues from "@/pages/Issues";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Corrections from "@/pages/Corrections";
import NotFound from "@/pages/NotFound";

const ScrollToTop = () => {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) {
            const el = document.querySelector(hash);
            if (el) {
                window.__lenis?.scrollTo(el, { offset: -80 });
                return;
            }
        }
        window.__lenis?.scrollTo(0, { immediate: true });
        window.scrollTo(0, 0);
    }, [pathname, hash]);
    return null;
};

function App() {
    useEffect(() => {
        const lenis = new Lenis({ autoRaf: true, lerp: 0.09 });
        window.__lenis = lenis;
        return () => {
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="App bg-ivory">
            <BrowserRouter>
                <ScrollToTop />
                <Header />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/milton" element={<Municipality slug="milton" />} />
                    <Route path="/oakville" element={<Municipality slug="oakville" />} />
                    <Route path="/burlington" element={<Municipality slug="burlington" />} />
                    <Route path="/halton-hills" element={<Municipality slug="halton-hills" />} />
                    <Route path="/candidates/:slug" element={<CandidateProfile />} />
                    <Route path="/issues" element={<Issues />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/corrections" element={<Corrections />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
                <Footer />
            </BrowserRouter>
            <Toaster position="bottom-right" richColors />
        </div>
    );
}

export default App;
